import React, { useState } from "react";
import { useUpdateScorecardNotes } from "hooks/api/scorecard";
import { useNotify } from "hooks";
import { InputNameDialog } from "components";

interface NotesModalProps {
    open: boolean;
    onClose: () => void;
    initialNotes?: string;
    dataId: number;
}

export const NotesModal: React.FC<NotesModalProps> = ({
    open,
    onClose,
    initialNotes = "",
    dataId,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const updateNotesMutation = useUpdateScorecardNotes();
    const notify = useNotify();

    const handleSave = async (notes: string) => {

        setIsLoading(true);
        try {
            await updateNotesMutation.mutateAsync({ dataId, notes });
            notify.success("Notes saved successfully!");
            onClose();
        } catch (error) {
            notify.error(error as string || "Failed to save notes. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        if (!isLoading) {
            onClose();
        }
    };

    return (
        <InputNameDialog
            isOpen={open}
            onClose={handleClose}
            mainTitle="Notes"
            onSubmit={handleSave}
            placeholder="Type your note..."
            defaultValue={initialNotes}
            allowEmptyValue
            textFieldSx={{ width: '492px', height: '79px', "& .MuiInputBase-root.MuiOutlinedInput-root": { minHeight: '79px', alignItems: 'flex-start' } }}
        />
    );
};
